export default __webpack_public_path__ + "static/ota-f7a3160fa6e967372a1a5e52455faee7.png";